import React from "react";

export default function InfoCard({ icon: Icon, title, children }) {
  return (
    <div className="bg-card border border-border/50 p-6 md:p-8 h-full">
      <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center mb-4">
        <Icon className="w-5 h-5 text-primary" aria-hidden="true" />
      </div>
      <h3 className="font-display text-lg text-foreground mb-3">{title}</h3>
      <div className="font-body text-sm text-muted-foreground leading-relaxed">{children}</div>
    </div>
  );
}